import script from "./AdminPluginManage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPluginManage.vue?vue&type=script&setup=true&lang=js"

import "./AdminPluginManage.vue?vue&type=style&index=0&id=87e0e678&scoped=true&lang=css"
import "./AdminPluginManage.vue?vue&type=style&index=1&id=87e0e678&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87e0e678"]])

export default __exports__